import React from 'react';
import { motion } from 'framer-motion';
import { Crown, Sparkles, Heart } from 'lucide-react';
const services = [{
  title: 'Premium Escort',
  subtitle: '高端伴游',
  description: 'Elite companions for social events, business functions, and intimate dates. Sophistication guaranteed.',
  icon: Crown
}, {
  title: 'Massage & Spa',
  subtitle: '按摩水疗',
  description: 'Relaxing therapeutic massage services in the comfort of your hotel or private residence.',
  icon: Sparkles
}, {
  title: 'VIP Companion',
  subtitle: '贵宾陪游',
  description: 'Exclusive travel companions for extended trips and vacations. The ultimate girlfriend experience.',
  icon: Heart
}];
export function ServiceCategories() {
  return <section id="services" className="py-24 bg-[#0a0a0a] relative" data-id="element-309">
      <div className="max-w-7xl mx-auto px-6" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-311">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-312">
            Our Services <span className="text-[#c9a96e]" data-id="element-313">服务项目</span>
          </h2>
          <div className="w-24 h-1 bg-[#c9a96e] mx-auto rounded-full opacity-50" data-id="element-314" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-315">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-[#111111] border border-[#c9a96e]/10 p-8 rounded-xl hover:border-[#c9a96e]/40 transition-all duration-500 hover:-translate-y-2" data-id="element-316">
              <div className="absolute inset-0 bg-gradient-to-b from-[#c9a96e]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-xl" data-id="element-317" />

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-318">
                <div className="w-16 h-16 rounded-full bg-[#0a0a0a] border border-[#c9a96e]/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500 group-hover:border-[#c9a96e] group-hover:shadow-[0_0_20px_rgba(201,169,110,0.2)]" data-id="element-319">
                  <service.icon className="text-[#c9a96e]" size={32} data-id="element-320" />
                </div>

                <h3 className="text-xl font-serif text-white mb-1" data-id="element-321">
                  {service.title}
                </h3>
                <p className="text-[#c9a96e] text-sm mb-4 font-medium" data-id="element-322">
                  {service.subtitle}
                </p>
                <p className="text-neutral-400 leading-relaxed text-sm" data-id="element-323">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}